export const zdConfig = {
  version: "2.4",
};
